var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor akinon-find-nearest-stock" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "akinon-find-nearest-stock-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [
        _vm._v(_vm._s(_vm.$t("akinon.productSKU"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { key: "sku", staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("akinon.typeOrSelectSKU"),
              rows: 1,
            },
            model: {
              value: _vm.clone.sku,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "sku", $$v)
              },
              expression: "clone.sku",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle" }, [
        _vm._v(_vm._s(_vm.$t("akinon.latitude"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { key: "latitude", staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("akinon.latitudeDesc"),
              rows: 1,
            },
            model: {
              value: _vm.clone.latitude,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "latitude", $$v)
              },
              expression: "clone.latitude",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inputTitle" }, [
        _vm._v(_vm._s(_vm.$t("akinon.longitude"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { key: "longitude", staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              placeholder: _vm.$t("akinon.longitude"),
              rows: 1,
            },
            model: {
              value: _vm.clone.longitude,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "longitude", $$v)
              },
              expression: "clone.longitude",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "active-connection" }, [
      _c("div", { staticClass: "logos", attrs: { "data-small": "true" } }, [
        _c("div", { staticClass: "logo1" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/supsis-logo2.png" },
          }),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
        _vm._v(" "),
        _c("div", { staticClass: "logo2" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/akinon.png" },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "active-connection-text" }, [
        _c("div", [
          _c("span", [_vm._v("Connected with")]),
          _vm._v(" "),
          _c("b", [_vm._v("Metabase API Akinon - Aydınlı ")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }